<header class="header">
    <nav class="navbar navbar-expand-lg px-4 py-2 bg-white shadow"><a class="sidebar-toggler text-gray-500 me-4 me-lg-5 lead" href="#"><i class="fas fa-align-left"></i></a><a class="navbar-brand fw-bold text-uppercase text-base" href="index.html"><img class="img-fluid rounded me-3" src="assets/img/Georgia-Pacific-logo.jpg" alt="GP" width="200"></a>
      <ul class="ms-auto d-flex align-items-center list-unstyled mb-0">
       
        <li><span>Welcome, Sanjay Datar</span></li>
       
        <li class="nav-item dropdown ms-auto"><a class="nav-link pe-0" id="userInfo" href="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img class="avatar p-1" src="assets/img/avatar-6.jpg" alt="Sanjay Datar"></a>
          <div class="dropdown-menu dropdown-menu-end dropdown-menu-animated" aria-labelledby="userInfo">
            <div class="dropdown-header text-gray-700">
              <h6 class="text-uppercase font-weight-bold">Mark Stephen</h6><small>Web Developer</small>
            </div>
            <div class="dropdown-divider"></div><a class="dropdown-item" href="#">Settings</a><a class="dropdown-item" href="#">Activity log       </a>
            <div class="dropdown-divider"></div><a class="dropdown-item" href="login.html">Logout</a>
          </div>
        </li>
      </ul>
    </nav>
  </header>